import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-background px-5 py-12 sm:py-20" data-id="element-72" data-mp="1hduloasc2p61">
      <div className="mx-auto max-w-2xl" data-id="element-73" data-mp="1cfjbfyy4mcna">
        <h2 className="text-center font-display text-2xl font-bold text-foreground sm:text-4xl" data-id="element-74" data-mp="1ccndwbq6xpzd">
          Preguntas <span className="text-pink" data-id="element-75" data-mp="29zw3ahtbbj6n">frecuentes</span>
        </h2>

        <div className="mt-8 divide-y divide-line border-y border-line" data-id="element-76" data-mp="253p0uz04kptg">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-77" data-mp="1v5hjif1xc5qx" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[48px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-78" data-mp="1v4g6i51cl96k">
                  <span className="text-sm font-semibold text-foreground sm:text-base" data-id="element-79" data-mp="jorj5ck6m858">
                    {faq.question}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary" data-id="element-80" data-mp="1klvw7za1thw8">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="1aqc2njiyivan" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="1arn4vewr7uzn" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-83" data-mp="11x8tvoj9b6mc">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-84" data-mp="11vnvfnttn3j7">
                      <p className="pb-4 text-sm leading-relaxed text-muted" data-id="element-85" data-mp="iz67lhi3fns8">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}